import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import WOW from 'wowjs';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import { Button } from 'reactstrap';
import { withStyles } from '@material-ui/core/styles';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import EventBus from "eventing-bus";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import VisibilitySensor from 'react-visibility-sensor';

import './index.css';
import '../../static/css/animate.css';
import 'animate.css';
import { toggleLoader, signUp } from "../../store/actions/Auth";

const CustomTextField = withStyles({
    root: {
        '& .MuiInputBase-input': {
            color: '#fff', // Text color
        },
        '& .MuiInput-underline:before': {
            borderBottomColor: '#fff', // Semi-transparent underline
        },
        '& .MuiInput-underline:hover:before': {
            borderBottomColor: '#fff', // Solid underline on hover
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#FA6634', // Solid underline on focus
        },
    },
    input: {
        '&:-webkit-autofill': {
            transitionDelay: '9999s',
            transitionProperty: 'background-color, color',
        }
    }
})(TextValidator);

const SignUp = () => {
    const [activationSection, setActiveSection] = useState('');
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        firstname: '',
        lastname: '',
        password: '',
        confirmPassword: '',
        agreeTerms: false,
        verifyAge: false,
    });
    const [isTermsAndConditionsModalOpen, setIsTermsAndConditionsModalOpen] = useState(false);

    const dispatch = useDispatch();
    const loading = useSelector(state => state.Auth.loading);
    const navigate = useNavigate();

    useEffect(() => {
        new WOW.WOW({ live: true }).init();
    }, []);

    const setVisible = (active) => {
        setActiveSection(prevSection => (prevSection === active ? '' : active));
    };

    const toggleTermsAndConditionsModal = () => {
        setIsTermsAndConditionsModalOpen(prevState => !prevState);
    };

    const handleCheckboxChange = (name) => {
        setFormData(prevState => ({
            ...prevState,
            [name]: !prevState[name],
        }));
    };

    const handleFormChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleFormSubmit = async () => {
        const { username, email, firstname, lastname, password, confirmPassword, agreeTerms, verifyAge } = formData;

        dispatch(toggleLoader(true));

        if (password !== confirmPassword) {
            EventBus.publish("error", "Password and Confirm Password do not match");
            dispatch(toggleLoader(false));
            return;
        }

        if (!agreeTerms || !verifyAge) {
            EventBus.publish("error", "Please accept our terms and conditions");
            dispatch(toggleLoader(false));
            return;
        }

        const fullName = `${firstname} ${lastname}`;
        const data = { username, email, password, name: fullName };

        await dispatch(signUp({ data, history: navigate }));

        dispatch(toggleLoader(false));
    };

    return (
        <div className="singup-page singup-without-sidebar">
                <VisibilitySensor onChange={() => setVisible('Singup')}>
                    <div className='content'>
                        <div className="signup-form">
                            <h2>Sign up</h2>
                            <p>Already have an account? <Link className="singin-btn" to="/SignIn">Sign In</Link></p>
                            <ValidatorForm className="validatorForm" onSubmit={handleFormSubmit}>
                                <Grid container spacing={1} className='group-input' alignItems="flex-end">
                                    <Grid className="signup-fields" item xs={12}>
                                        <CustomTextField
                                            fullWidth
                                            className="MyTextField"
                                            placeholder="User Name"
                                            autoComplete='off'
                                            name="username"
                                            type="text"
                                            value={formData.username}
                                            margin="dense"
                                            onChange={handleFormChange}
                                            validators={['required']}
                                            errorMessages={['User Name can not be empty']}
                                        />
                                    </Grid>
                                    <Grid className="signup-fields" item xs={12}>
                                        <CustomTextField
                                            fullWidth
                                            className="MyTextField"
                                            placeholder="Email address"
                                            autoComplete='off'
                                            name="email"
                                            type="email"
                                            value={formData.email}
                                            margin="dense"
                                            onChange={handleFormChange}
                                            validators={['required']}
                                            errorMessages={['Email address can not be empty']}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} className='group-input' alignItems="flex-end">
                                    <Grid className="signup-fields" item xs={6}>
                                        <CustomTextField
                                            fullWidth
                                            className="MyTextField"
                                            placeholder="First name"
                                            autoComplete='off'
                                            name="firstname"
                                            type="text"
                                            value={formData.firstname}
                                            margin="dense"
                                            onChange={handleFormChange}
                                            validators={['required']}
                                            errorMessages={['First name can not be empty']}
                                        />
                                    </Grid>
                                    <Grid className="signup-fields" item xs={6}>
                                        <CustomTextField
                                            fullWidth
                                            className="MyTextField"
                                            placeholder="Last name"
                                            autoComplete='off'
                                            name="lastname"
                                            type="text"
                                            value={formData.lastname}
                                            margin="dense"
                                            onChange={handleFormChange}
                                            validators={['required']}
                                            errorMessages={['Last name can not be empty']}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} className='group-input' alignItems="flex-end">
                                    <Grid className="signup-fields" item xs={12}>
                                        <CustomTextField
                                            fullWidth
                                            className="MyTextField"
                                            placeholder="Password"
                                            autoComplete='off'
                                            name="password"
                                            type="password"
                                            value={formData.password}
                                            margin="dense"
                                            onChange={handleFormChange}
                                            validators={['required']}
                                            errorMessages={['Password can not be empty']}
                                        />
                                    </Grid>
                                    <Grid className="signup-fields" item xs={12}>
                                        <CustomTextField
                                            fullWidth
                                            className="MyTextField"
                                            placeholder=" Confirm Password"
                                            autoComplete='off'
                                            name="confirmPassword"
                                            type="password"
                                            value={formData.confirmPassword}
                                            margin="dense"
                                            onChange={handleFormChange}
                                            validators={['required']}
                                            errorMessages={[' Confirm Password can not be empty']}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} className='group-input' alignItems="flex-end">
                                    <Grid className="signup-fields" item xs={6}>
                                        <Checkbox
                                            checked={formData.agreeTerms}
                                            onChange={() => handleCheckboxChange("agreeTerms")}
                                        />
                                        <label>You Agree <span className='singin-btn' onClick={toggleTermsAndConditionsModal}>Terms and Services</span></label>
                                    </Grid>
                                    <Grid className="signup-fields" item xs={6}>
                                        <Checkbox
                                            checked={formData.verifyAge}
                                            onChange={() => handleCheckboxChange("verifyAge")}
                                        />
                                        <label>Please verify your age is 18</label>
                                    </Grid>
                                </Grid>
                                <Button
                                    type="submit"
                                    disabled={loading}
                                >
                                    {!loading ? 'Sign Up' : <i className="fa fa-spinner fa-spin fa-1x fa-fw" />}
                                </Button>
                            </ValidatorForm>
                        </div>
                    </div>
                </VisibilitySensor>
                {/* --------------- temsAndConditions! Modal--------------- */}
                <Modal isOpen={isTermsAndConditionsModalOpen} toggle={toggleTermsAndConditionsModal} className={`main-modal trems-modal`}>
                  <ModalHeader toggle={toggleTermsAndConditionsModal}></ModalHeader>
                  <ModalBody>
                      <div className='content-area'>
                          <h2>Terms and Services</h2>
                          <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                          <p>YLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                      </div>
                  </ModalBody>
              </Modal>
            </div> 
        );
}

export default SignUp;

